export const SETTLE_MODAL_MOBILE_MAX_WIDTH = '1020px'
